import router from '@/router'

export default {
  id: process.env.VUE_APP_GA || '',
  router
}
